import { useState } from 'react'
import { LayerProps } from 'react-map-gl'
import type { Expression, GeoJSONSourceRaw } from 'mapbox-gl'
import { SymbolLayer } from 'mapbox-gl'

import {
  booksRadiusEndpoint,
  booksRouteURL,
  initialLatitudePosition,
  initialLongitudePosition,
  paint,
  placesLayout,
  priority,
  radiusFromLocation
} from './common'
import { FeatureCollection } from 'geojson'

declare type GeoJSONSourceProps = GeoJSONSourceRaw & {
  id?: string
}

export let placesSource: GeoJSONSourceProps = {
  id: 'places',
  type: 'geojson',
  /*data: `${booksRouteURL}${booksRadiusEndpoint}?longitude=${initialLongitudePosition}&latitude=${initialLatitudePosition}&radius=${radiusFromLocation}`,*/
  data: {} as FeatureCollection,
  generateId: true,
  cluster: true,
  clusterRadius: 30,
  clusterMaxZoom: 16,
  //clusterMinPoints: 3, // needs new mapbox version than 1.8.1, but that moves reported cursor position down by navbar height;
  clusterProperties: {
    clusterName: [
      [
        'case',
        ['==', ['accumulated'], ['get', 'clusterName']],
        ['get', 'clusterName'],
        null
      ],
      ['get', 'name']
    ]
  }
  // attribution:
  //   'Not for Navigation | &copy; Imray, Laurie, Norie and Wilson Ltd'
}

export const placesLayerStyle: SymbolLayer = {
  id: 'places',
  type: 'symbol',
  source: 'places',
  filter: ['!', ['has', 'point_count']],
  layout: placesLayout,
  paint: paint
}

interface UseLayerPropsState {
  placesLayerStyle: LayerProps
  togglePlacesLayerOpacity: (e?: boolean) => void
}

export const usePlaceLayerStyle = (): UseLayerPropsState => {
  const [layerStyle, setLayerStyle] = useState<SymbolLayer>(placesLayerStyle)
  const toggleOpacity = (isHighLight?: boolean) => {
    if (isHighLight) {
      setLayerStyle(state => ({
        ...state,
        paint: {
          ...state.paint,
          'icon-opacity': ['match', ['feature-state', 'active'], 1, 1, 0.5]
        }
      }))
    } else {
      setLayerStyle(state => ({
        ...state,
        paint: {
          ...state.paint,
          'icon-opacity': 1
        },
        layout: {
          ...state.layout,
          'symbol-sort-key': priority as Expression
        }
      }))
    }
  }
  return {
    placesLayerStyle: layerStyle,
    togglePlacesLayerOpacity: toggleOpacity
  }
}
